import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const DoubleHomePixelIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_2022_13601)">
        <g clipPath="url(#clip1_2022_13601)">
          <path d="M39.0012 42H33.0005V48H39.0012V42Z" fill={fillColor || 'black'} />
          <path d="M18.0008 42H12V48H18.0008V42Z" fill={fillColor || 'black'} />
          <path d="M39.0012 36H33.0005V39.0008H39.0012V36Z" fill={fillColor || 'black'} />
          <path d="M18.0008 36H12V39.0008H18.0008V36Z" fill={fillColor || 'black'} />
          <path d="M42.0006 30H39.001V33.0008H42.0006V30Z" fill={fillColor || 'black'} />
          <path d="M12.0001 30H9.00049V33.0008H12.0001V30Z" fill={fillColor || 'black'} />
          <path
            d="M6.00076 30H9.00038V27.0008H6.00076V24H9.00038V21.0008H6.00076V18H9.00038V15.0008H6.00076V12H2.99962V18H0V45.0008H2.99962V48H6.00076V36H9.00038V33.0008H6.00076V30Z"
            fill={fillColor || 'black'}
          />
          <path d="M38.9996 27.001H36V30.0002H38.9996V27.001Z" fill={fillColor || 'black'} />
          <path d="M33.0006 27.001H30.001V30.0002H33.0006V27.001Z" fill={fillColor || 'black'} />
          <path
            d="M26.9997 27.001H30.0009V24.0002H26.9997V21.001H30.0009V18.0002H26.9997V15.001H30.0009V12.0002H26.9997V9.00098H24.0001V30.0002H21.0005V33.001H24.0001V48.0002H26.9997V33.001H30.0009V30.0002H26.9997V27.001Z"
            fill={fillColor || 'black'}
          />
          <path d="M21.0006 27.001H18.001V30.0002H21.0006V27.001Z" fill={fillColor || 'black'} />
          <path d="M14.9996 27.001H12V30.0002H14.9996V27.001Z" fill={fillColor || 'black'} />
          <path d="M12.0001 24H9.00049V27.0008H12.0001V24Z" fill={fillColor || 'black'} />
          <path
            d="M36.0002 6H39.0014V2.99924H36.0002V0H33.0006V2.99924H30.001V6H33.0006V9.00076H30.001V12H33.0006V15.0008H30.001V18H33.0006V21.0008H30.001V24H33.0006V27.0008H36.0002V6Z"
            fill={fillColor || 'black'}
          />
          <path
            d="M18.0008 6H21.0004V2.99924H18.0008V0H14.9996V2.99924H12V6H14.9996V9.00076H12V12H14.9996V15.0008H12V18H14.9996V21.0008H12V24H14.9996V27.0008H18.0008V6Z"
            fill={fillColor || 'black'}
          />
          <path d="M12.0001 18H9.00049V21.0008H12.0001V18Z" fill={fillColor || 'black'} />
          <path d="M45.0006 33.0008H42.001V36H45.0006V48H48.0002V12H45.0006V33.0008Z" fill={fillColor || 'black'} />
          <path d="M12.0001 12H9.00049V14.9992H12.0001V12Z" fill={fillColor || 'black'} />
          <path d="M45.0006 9.00098H42.001V12.0017H45.0006V9.00098Z" fill={fillColor || 'black'} />
          <path d="M9.0006 9.00098H6.00098V12.0017H9.0006V9.00098Z" fill={fillColor || 'black'} />
          <path d="M42.0006 6H39.001V8.99924H42.0006V6Z" fill={fillColor || 'black'} />
          <path d="M29.9991 6H26.9995V8.99924H29.9991V6Z" fill={fillColor || 'black'} />
          <path d="M24.0001 6H21.0005V8.99924H24.0001V6Z" fill={fillColor || 'black'} />
          <path d="M12.0001 6H9.00049V8.99924H12.0001V6Z" fill={fillColor || 'black'} />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2022_13601">
          <rect width="48" height="48" fill={fillColor || 'white'} />
        </clipPath>
        <clipPath id="clip1_2022_13601">
          <rect width="48" height="48" fill={fillColor || 'white'} />
        </clipPath>
      </defs>
    </svg>
  );
};

export { DoubleHomePixelIcon };
